// extracted by mini-css-extract-plugin
export default {"item_img":"Post_item_img__cy-df"};